import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "license-verified",
      class: { "d-inline-flex": _setup.isIconVariant },
    },
    [
      _setup.isIconVariant
        ? _c("div", {
            staticClass:
              "license-verified__icon ui-icon-shield-checkmark-40 success--text flex-shrink-0 cursor-pointer",
            attrs: {
              role: "button",
              tabindex: "0",
              "aria-label": _setup.translate("Лицензия проверена"),
              "data-qa": "license-verified-icon",
            },
            on: {
              click: function ($event) {
                _setup.isOpened = true
              },
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  _setup.isOpened = true
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  _setup.isOpened = true
                },
              ],
            },
          })
        : _c(
            "div",
            {
              staticClass:
                "d-flex align-center gc-2 rounded px-2 py-1 bg-success cursor-pointer text-success--text",
              attrs: { "data-qa": "license-verified-plate" },
              on: {
                click: function ($event) {
                  _setup.isOpened = true
                },
              },
            },
            [
              _c("div", {
                staticClass:
                  "ui-icon-shield-check ui-icon-fz-medium flex-shrink-0",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.translate("Лицензия проверена")) +
                    "\n    "
                ),
              ]),
            ]
          ),
      _vm._v(" "),
      _c(
        _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
        _vm._b(
          {
            tag: "component",
            scopedSlots: _vm._u(
              [
                !_setup.isMobile
                  ? {
                      key: "prependBtn",
                      fn: function ({ btnProps }) {
                        return [
                          _c(
                            VBtn,
                            _vm._b(
                              {
                                on: {
                                  click: function ($event) {
                                    _setup.isOpened = false
                                  },
                                },
                              },
                              "v-btn",
                              btnProps,
                              false
                            ),
                            [
                              _c("span", {
                                staticClass: "ui-icon-close-not-a-circle",
                              }),
                            ]
                          ),
                        ]
                      },
                    }
                  : null,
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          staticClass:
                            "primary--text branding-btn branding-btn--background",
                          attrs: {
                            color: "bg-primary",
                            depressed: "",
                            block: "",
                          },
                          on: {
                            click: function ($event) {
                              _setup.isOpened = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.translate("Хорошо")) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
            model: {
              value: _setup.isOpened,
              callback: function ($$v) {
                _setup.isOpened = $$v
              },
              expression: "isOpened",
            },
          },
          "component",
          _setup.isMobile
            ? {}
            : {
                title: _setup.translate("Лицензия проверена"),
                divider: true,
                size: "md",
              },
          false
        ),
        [
          _vm._v(" "),
          _setup.isMobile
            ? _c(
                "div",
                { staticClass: "d-flex align-center gc-4 mb-2" },
                [
                  _c(VIcon, { attrs: { color: "success", size: "24" } }, [
                    _vm._v("\n        ui-icon-shield-checkmark-40\n      "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-h6 text-success--text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.translate("Лицензия проверена")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.translate("Лицензия клиники:")) +
                "\n      "
            ),
            _c("br"),
            _vm._v(_vm._s(_vm.license) + "\n    "),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }